export default "__VITE_ASSET__d89cd31f__"